import { render, staticRenderFns } from "./TunnelCustomFields.vue?vue&type=template&id=4ce4f3e0"
import script from "./TunnelCustomFields.vue?vue&type=script&lang=js"
export * from "./TunnelCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports